<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="app-content d-flex flex-column min-vh-100">
  <main class="flex-grow-1 h-100">
    <app-sidebar *ngIf="showSideBar$ | async"></app-sidebar>
    <router-outlet></router-outlet>
  </main>
  <div *ngIf="showOfflineModal" class="offline-modal-backdrop">
    <div class="offline-modal">
      <h2>🔌 Offline Mode</h2>
      <p>
        You are not connected to the internet. Some features may not work
        properly.
      </p>
      <button (click)="dismissModal()">Ok</button>
    </div>
  </div>

  <app-footer></app-footer>
  <app-toast></app-toast>
  <app-confirmation-popup></app-confirmation-popup>
</div>